/* NECCST interactive grind size chart.
   Ported from the design comp; data (methods, categories, scale max, units per
   turn) is read from the section's JSON <script> tags + data-* attributes so all
   copy stays editable in the theme editor. One card per section; re-inits cleanly
   on shopify:section:load. */
(function () {
  function parseJSON(el) { try { return JSON.parse(el.textContent); } catch (e) { return []; } }

  function build(card) {
    var methodsEl = card.querySelector('.gc-data-methods');
    var catsEl = card.querySelector('.gc-data-cats');
    var METHODS = methodsEl ? parseJSON(methodsEl) : [];
    var CATS = catsEl ? parseJSON(catsEl) : [];
    if (!METHODS.length) return;

    var MAX = parseInt(card.getAttribute('data-max'), 10) || 350;
    var TURN = parseInt(card.getAttribute('data-turn'), 10) || 150;

    var elNames = card.querySelector('#gcNames'), elTicks = card.querySelector('#gcTicks'),
        elGrid = card.querySelector('#gcGrid'), elRows = card.querySelector('#gcRows'),
        elCats = card.querySelector('#gcCats'), elField = card.querySelector('#gcField'),
        elMarker = card.querySelector('#gcMarker'), elFlag = card.querySelector('#gcFlag');
    var elBig = card.querySelector('#gcBig'), elDial = card.querySelector('#gcDial'),
        elRlabel = card.querySelector('#gcRlabel'), elCatBadge = card.querySelector('#gcCatBadge'),
        elCtxLabel = card.querySelector('#gcCtxLabel'), elCtxBody = card.querySelector('#gcCtxBody'),
        elMobile = card.querySelector('#gcMobile');
    if (!elNames || !elRows || !elField) return;

    // Clear any prior build (theme-editor re-render)
    [elNames, elTicks, elGrid, elRows, elCats, elMobile].forEach(function (n) { if (n) n.innerHTML = ''; });

    var readingLabel = elRlabel ? elRlabel.textContent : 'Reading';
    var suitedLabel = elCtxLabel ? elCtxLabel.textContent : 'Suited to';

    var state = { mode: 'both', dial: true, marker: 120, focus: null, lock: false };
    try { var saved = parseInt(localStorage.getItem('neccst-grind-marker'), 10); if (!isNaN(saved)) state.marker = Math.min(MAX, Math.max(0, saved)); } catch (e) {}

    function pct(v) { return v / MAX * 100; }
    function find(id) { return METHODS.filter(function (m) { return m.id === id; })[0]; }
    function catOf(v) { for (var i = 0; i < CATS.length; i++) { if (v >= CATS[i].lo && v <= CATS[i].hi) return CATS[i].name; } return CATS.length ? CATS[CATS.length - 1].name : ''; }
    function turnsOf(v) { return Math.floor(v / TURN); }
    function turnBadge(n) { return '<span class="dturn">' + n + '</span>'; }
    function dialMark(v) { v = Math.round(v); var t = turnsOf(v); var r = v - t * TURN; if (t === 0) return '' + r; if (r === 0) return turnBadge(t); return turnBadge(t) + '+' + r; }
    function rangeDial(lo, hi) { return dialMark(lo) + ' → ' + dialMark(hi); }
    function activeAt(v) { return METHODS.filter(function (m) { return v >= m.lo && v <= m.hi; }); }

    var bars = {}, names = {}, names2 = {};
    METHODS.forEach(function (m) {
      var n = document.createElement('div'); n.className = 'gc-name'; n.textContent = m.name; n.title = m.name; n.dataset.id = m.id;
      elNames.appendChild(n); names[m.id] = n;
      var row = document.createElement('div'); row.className = 'gc-row';
      var rn = document.createElement('span'); rn.className = 'gc-rowname'; rn.textContent = m.name; rn.dataset.id = m.id;
      var b = document.createElement('button'); b.type = 'button'; b.className = 'gc-bar'; b.dataset.id = m.id;
      b.style.left = pct(m.lo) + '%'; b.style.width = pct(m.hi - m.lo) + '%';
      b.setAttribute('aria-label', m.name + ', grind ' + m.lo + ' to ' + m.hi);
      row.appendChild(rn); row.appendChild(b); elRows.appendChild(row); bars[m.id] = b; names2[m.id] = rn;
    });
    for (var v = 0; v <= MAX; v += 25) {
      var gl = document.createElement('div'); gl.className = 'gc-gl' + (v % 50 === 0 ? ' major' : ''); gl.style.left = pct(v) + '%'; elGrid.appendChild(gl);
      if (v % 50 === 0) { var t = document.createElement('div'); t.className = 'gc-tick'; t.style.left = pct(v) + '%'; t.textContent = v; elTicks.appendChild(t); }
    }
    CATS.forEach(function (c) {
      var d = document.createElement('div'); d.className = 'gc-cat'; d.dataset.name = c.name;
      var full = document.createElement('span'); full.className = 'gc-cat-full'; full.textContent = c.name;
      var ab = document.createElement('span'); ab.className = 'gc-cat-ab'; ab.textContent = c.ab;
      d.appendChild(full); d.appendChild(ab); elCats.appendChild(d);
    });

    // Mobile compact list
    var mRows = {};
    function rowDial(m) { return rangeDial(m.lo, m.hi); }
    if (elMobile) {
      var mlist = document.createElement('div'); mlist.className = 'gcm-list';
      METHODS.forEach(function (m) {
        var r = document.createElement('button'); r.type = 'button'; r.className = 'gcm-row'; r.dataset.id = m.id; r.setAttribute('aria-expanded', 'false');
        var top = document.createElement('span'); top.className = 'gcm-rtop';
        var nm = document.createElement('span'); nm.className = 'gcm-rname'; nm.textContent = m.name;
        var rg = document.createElement('span'); rg.className = 'gcm-rrange'; rg.textContent = m.lo + '–' + m.hi;
        var ch = document.createElement('span'); ch.className = 'gcm-chev'; ch.setAttribute('aria-hidden', 'true');
        top.appendChild(nm); top.appendChild(rg); top.appendChild(ch);
        var tr = document.createElement('span'); tr.className = 'gcm-rtrack';
        var fi = document.createElement('i'); fi.className = 'gcm-rfill'; fi.style.left = pct(m.lo) + '%'; fi.style.width = pct(m.hi - m.lo) + '%'; tr.appendChild(fi);
        var dl = document.createElement('span'); dl.className = 'gcm-rdial';
        var dlab = document.createElement('span'); dlab.className = 'gcm-dlabel'; dlab.textContent = 'Dial'; dl.appendChild(dlab);
        var dval = document.createElement('span'); dval.innerHTML = rowDial(m); dl.appendChild(dval);
        var nt = document.createElement('span'); nt.className = 'gcm-rnote'; nt.textContent = m.note;
        r.appendChild(top); r.appendChild(tr); r.appendChild(dl); r.appendChild(nt);
        mlist.appendChild(r); mRows[m.id] = r;
      });
      elMobile.appendChild(mlist);
    }

    function render() {
      card.classList.remove('mode-both', 'mode-marker', 'mode-methods');
      card.classList.add('mode-' + state.mode);
      if (elDial) elDial.dataset.off = state.dial ? '0' : '1';
      elMarker.style.left = pct(state.marker) + '%';
      elFlag.textContent = Math.round(state.marker);
      elFlag.setAttribute('aria-valuenow', Math.round(state.marker));
      var focusM = state.focus ? find(state.focus) : null;
      var showMethod = (state.mode !== 'marker') && !!focusM;
      var inRange = (state.mode !== 'methods');
      METHODS.forEach(function (m) {
        var b = bars[m.id], n = names[m.id], rn = names2[m.id];
        b.classList.toggle('inrange', inRange && state.marker >= m.lo && state.marker <= m.hi);
        var isF = showMethod && focusM.id === m.id;
        var isDim = state.mode === 'methods' && !!focusM && !isF;
        b.classList.toggle('focus', !!isF);
        [n, rn].forEach(function (x) { x.classList.toggle('focus', !!isF); x.classList.toggle('dim', isDim); });
      });
      var actCats = {};
      if (showMethod) { CATS.forEach(function (c) { if (focusM.lo < c.hi && focusM.hi > c.lo) actCats[c.name] = 1; }); }
      else { actCats[catOf(state.marker)] = 1; }
      elCats.querySelectorAll('.gc-cat').forEach(function (d) { d.classList.toggle('active', !!actCats[d.dataset.name]); });
      if (showMethod) {
        elRlabel.textContent = focusM.name;
        elBig.textContent = focusM.lo + '–' + focusM.hi;
        elDial.innerHTML = 'Dial reading &nbsp;<b>' + rangeDial(focusM.lo, focusM.hi) + '</b>';
        elCatBadge.textContent = Object.keys(actCats).join(' · '); elCatBadge.style.display = '';
        elCtxLabel.textContent = 'Notes';
        var note = document.createElement('p'); note.className = 'gc-note'; note.textContent = focusM.note;
        elCtxBody.innerHTML = ''; elCtxBody.appendChild(note);
      } else {
        var val = Math.round(state.marker);
        elRlabel.textContent = readingLabel;
        elBig.textContent = val;
        elDial.innerHTML = 'Set the dial to &nbsp;<b>' + dialMark(val) + '</b>';
        elCatBadge.textContent = catOf(val); elCatBadge.style.display = '';
        elCtxLabel.textContent = suitedLabel;
        var act = activeAt(val);
        if (act.length) {
          elCtxBody.innerHTML = '';
          var chips = document.createElement('div'); chips.className = 'gc-chips';
          act.forEach(function (m) {
            var c = document.createElement('button'); c.type = 'button'; c.className = 'gc-chip on'; c.dataset.id = m.id; c.textContent = m.name;
            chips.appendChild(c);
          });
          elCtxBody.appendChild(chips);
        } else {
          var sp = document.createElement('span'); sp.className = 'gc-empty';
          sp.textContent = val < METHODS[0].lo ? 'Finer than any listed method.' : 'Coarser than any listed method.';
          elCtxBody.innerHTML = ''; elCtxBody.appendChild(sp);
        }
      }
      if (elMobile) { elMobile.dataset.dial = state.dial ? '1' : '0'; }
    }

    function setMarker(val, persist) {
      state.marker = Math.min(MAX, Math.max(0, Math.round(val)));
      if (state.mode !== 'methods') { state.focus = null; state.lock = false; }
      render();
      if (persist !== false) { try { localStorage.setItem('neccst-grind-marker', state.marker); } catch (e) {} }
    }
    function valFromX(x) { var r = elField.getBoundingClientRect(); return (x - r.left) / r.width * MAX; }

    var dragging = false;
    elField.addEventListener('pointerdown', function (e) { if (state.mode === 'methods') return; if (e.target.closest('.gc-bar') || e.target.closest('.gc-rowname')) return; dragging = true; try { elField.setPointerCapture(e.pointerId); } catch (_) {} setMarker(valFromX(e.clientX)); e.preventDefault(); });
    elField.addEventListener('pointermove', function (e) { if (dragging) setMarker(valFromX(e.clientX)); });
    window.addEventListener('pointerup', function () { dragging = false; });
    elFlag.addEventListener('pointerdown', function (e) { if (state.mode === 'methods') return; dragging = true; try { elField.setPointerCapture(e.pointerId); } catch (_) {} e.stopPropagation(); e.preventDefault(); });
    elFlag.addEventListener('keydown', function (e) { if (state.mode === 'methods') return; var s = e.shiftKey ? 10 : 1; if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { setMarker(state.marker + s); e.preventDefault(); } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { setMarker(state.marker - s); e.preventDefault(); } else if (e.key === 'Home') { setMarker(0); e.preventDefault(); } else if (e.key === 'End') { setMarker(MAX); e.preventDefault(); } });

    Object.keys(bars).forEach(function (id) {
      var b = bars[id], n = names[id], rn = names2[id];
      [b, n, rn].forEach(function (el) {
        el.addEventListener('mouseenter', function () { if (state.mode === 'marker') return; if (state.mode === 'both' && state.lock) return; state.focus = id; render(); });
        el.addEventListener('mouseleave', function () { if (state.mode === 'both' && !state.lock) { state.focus = null; render(); } });
        el.addEventListener('click', function () {
          if (state.mode === 'marker') { var m = find(id); setMarker((m.lo + m.hi) / 2); return; }
          if (state.mode === 'methods') { state.focus = id; state.lock = true; render(); return; }
          if (state.lock && state.focus === id) { state.lock = false; state.focus = null; } else { state.focus = id; state.lock = true; } render();
        });
      });
      b.addEventListener('focus', function () { if (state.mode !== 'marker') { state.focus = id; render(); } });
    });
    elCtxBody.addEventListener('click', function (e) { var c = e.target.closest('.gc-chip'); if (!c) return; var id = c.dataset.id; if (state.mode === 'marker') { var m = find(id); setMarker((m.lo + m.hi) / 2); } else { state.focus = id; state.lock = true; render(); } });

    Object.keys(mRows).forEach(function (id) {
      mRows[id].addEventListener('click', function () {
        var open = mRows[id].getAttribute('aria-expanded') === 'true';
        Object.keys(mRows).forEach(function (k) { mRows[k].setAttribute('aria-expanded', 'false'); });
        mRows[id].setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    render();
  }

  function init(root) {
    var scope = root && root.querySelector ? root : document;
    scope.querySelectorAll('.grind-card').forEach(build);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
